import Embellishment from '../../components/Embellishment'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import JoinConversationSection from './JoinConversationSection'
import Page from '../../components/Page'

const HomePage = () => {
  return (
    <Page>
      <Stack>
        <Container
          sx={{
            zIndex: 1,
          }}
        >
          <Stack
            display="grid"
            pt={2}
            pb={6}
            gap={4}
          >
            <JoinConversationSection />
          </Stack>
        </Container>
        <Embellishment />
      </Stack>
    </Page>
  )
}

export default HomePage
